export const REFERENCE_TEMPERATURE_IN_CELSIUS_PROPERTIES = [
  "Density",
  "Dynamic Viscosity",
  "Kinematic Viscosity",
];
